<template>
  <div class="modal fade confirmation-modal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    id="confirmation-modal">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="container py-4 px-4">
          <label style="text-align: center;">{{ message }}</label>

          <div style="text-align: center">
            <button class="btn mr-1"
              style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
              @click="hideModal('#confirmation-modal')">
              Cancel
            </button>

            <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
              @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { type } from 'jquery';
import InputLabel from '../../../components/UI/InputLabel.vue';


export default {
  name: "confirmation-modal",
  
  components: {
    InputLabel
  },

  props: {
    message: {
      type: String,
      required: false,
      default: 'Are you sure you want to update?'
    },
  },

  data() {
    return {
      data: {
        title: '',
        start_date: '',
        end_date: '',
        type: ''
      },


    };
  },

  methods: {
    hideModal(name) {
      $(name).modal('hide');
    },

    handleSubmit() {
      this.$emit("submitConfirmation");
    },
  },
};
</script>
